import { useNavigate } from 'react-router-dom';
export default function ReportButton() {
const navigate = useNavigate();
return (
<button
onClick={() => navigate('/report')}
className="fixed bottom-4 right-4 z-50 group flex items-center gap-1 px-2 py-1.5 bg-white border border-[#d9d9d9] text-[#595959] text-xs rounded-[4px] hover:bg-[#fafafa] hover:border-[#bfbfbf] transition-colors duration-200 cursor-pointer whitespace-nowrap sm:bottom-8 sm:right-6 sm:gap-1.5 sm:px-3 sm:py-2 sm:text-[13px]"
aria-label="投诉举报"
>
<i className="ri-feedback-line text-sm sm:text-base" />
<span className="text-xs sm:text-[13px]">投诉举报</span>
</button>
);
}